import { createElement, forwardRef } from 'react'

import { splitProps } from '../helpers.mjs';
import { getLevelLeftStyle } from '../patterns/level-left.mjs';
import { styled } from './factory.mjs';

export const LevelLeft = /* @__PURE__ */ forwardRef(function LevelLeft(props, ref) {
  const [patternProps, restProps] = splitProps(props, [])

const styleProps = getLevelLeftStyle(patternProps)
const mergedProps = { ref, ...styleProps, ...restProps }

return createElement(styled.div, mergedProps)
  })